import { Component, inject, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Meta, Title } from '@angular/platform-browser';
import {NgForOf} from "@angular/common";

@Component({
    selector: 'app-delivery-areas',
    imports: [
        NgForOf
    ],
    templateUrl: './delivery-area.component.html',
    styleUrl: './delivery-area.component.scss'
})
export class DeliveryAreaComponent implements OnInit {
  private meta = inject(Meta);
  private title = inject(Title);
  locations = [
    {
      name: 'Allentown'
    },
    {
      name: 'Ancient Oaks'
    },
    {
      name: 'Ballietsville'
    },
    {
      name: 'Bethlehem'
    },
    {
      name: 'Bethlehem Township'
    },
    {
      name: 'Bridle Path'
    },
    {
      name: 'Butztown'
    },
    {
      name: 'Center Valley'
    },
    {
      name: 'Chestnut Hill'
    },
    {
      name: 'Cetronia'
    },
    {
      name: 'College Hill'
    },
    {
      name: 'Cross Creek'
    },
    {
      name: 'Dorneyville'
    },
    {
      name: 'East Texas'
    },
    {
      name: 'Easton'
    },
    {
      name: 'Emmaus'
    },
    {
      name: 'Egypt'
    },
    {
      name: 'Fountain Hill'
    },
    {
      name: 'Fogelsville'
    },
    {
      name: 'Freemansburg'
    },
    {
      name: 'Greenawalds'
    },
    {
      name: 'Hillside'
    },
    {
      name: 'Ironton'
    },
    {
      name: 'Krocksville'
    },
    {
      name: 'Kuhnsville'
    },
    {
      name: 'Liberty Park'
    },
    {
      name: 'Lincoln Terrace'
    },
    {
      name: 'Lower Bath'
    },
    {
      name: 'Maple Shade Estates'
    },
    {
      name: 'Mickley Gardens'
    },
    {
      name: 'Mill Creek'
    },
    {
      name: 'Minsite'
    },
    {
      name: 'Mount Airy'
    },
    {
      name: 'Neffs'
    },
    {
      name: 'Northampton'
    },
    {
      name: 'Orefield'
    },
    {
      name: 'Palmer Heights'
    },
    {
      name: 'Parkside Courts'
    },
    {
      name: 'Parkview Estates'
    },
    {
      name: 'Rose Garden'
    },
    {
      name: 'Ruppsville'
    },
    {
      name: 'Scherersville'
    },
    {
      name: 'Schnecksville'
    },
    {
      name: 'Seiple'
    },
    {
      name: 'Stanley Place'
    },
    {
      name: 'Stiles'
    },
    {
      name: 'Trexlertown'
    },
    {
      name: 'Trexler Park'
    },
    {
      name: 'Walters'
    },
    {
      name: 'West End Allentown'
    },
    {
      name: 'Westgate Hills'
    },
    {
      name: 'Whitehall'
    },
    {
      name: 'Wennersville'
    },
  ]
  ngOnInit(): void {
    this.setUpSEOTags()
  }

  private setUpSEOTags() {
    const { baseTitle, baseURL, type } = environment.config.seo;
    const url = 'pages/delivery-areas'
    const component = 'Delivery Areas'
    const title = `${component} | ${baseTitle}`;

    // Page title
    this.title.setTitle(title);

    // Open Graph for social networks:
    this.meta.addTag({ property: 'og:title', content: title });
    this.meta.addTag({ property: 'og:url', content: `${baseURL}${url}` });
    this.meta.addTag({ property: 'og:type', content: type });
  }
}
